export default __webpack_public_path__ + "static/media/title-asset.23662b75.svg";